import React, { FC } from 'react';
import classNames from 'classnames';
import style from './FormHint.module.scss';

interface IFormHintProps extends React.HTMLAttributes<HTMLDivElement> {
  error?: boolean
}

const FormHint: FC<IFormHintProps> = ({
  className, children, error, ...props
}) => (
  <div
    className={classNames(style.hint, className, {
      [style.error]: error,
    })}
    {...props}
  >
    {children}
  </div>
);
export default FormHint;
